<template>
  <div id="NoticeList">
    <div class="assets-comment-all">
      <div>
        <div class="cardContent">
          <div
            v-for="(item, index) in list"
            :key="index"
            @click="goNoticeDetail(item.id)"
          >
            <el-row>
              <el-col :span="1">
                <span
                  style="display:inline-block;width:100%;"
                ><i v-if="item.sign" class="el-icon-star-off"></i></span>
              </el-col>
              <el-col :span="14" class="notice_content"><span v-if="item.newnotice" class="newnotice">new</span>{{ item.title }}</el-col>
              <el-col :span="9" class="alignRight">{{ item.time }}</el-col>
            </el-row>
          </div>
        </div>

        <el-row v-if="selectPage === 1">
          <el-col :span="24">
            <el-pagination
              popper-class="_popStyle"
              :current-page="pageData.currentPage"
              :page-sizes="pageData.pageSizes"
              :page-size="pageData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="24">
            <el-pagination
              popper-class="_popStyle"
              :current-page="pageData1.currentPage"
              :page-sizes="pageData1.pageSizes"
              :page-size="pageData1.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageData1.total"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
export default {
  name: 'NoticeList',
  data() {
    return {
      list: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      pageData1: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      selectPage: 1, // 1公告列表,2项目公告
      inputSearch: ''
    }
  },
  mounted() {
    // let num = window.sessionStorage.getItem('selectnPage')
    // if( num==1){
    this.selectPage = 1
    // }else{
    // this.selectPage = 2
    // protocol.param_getArticle.param.classifyId = 3;
    // }

    // protocol.param_getArticle.param.classifyId = 2;
    this.getArticle()
  },
  methods: {
    goNoticeDetail(id) {
      const newids = JSON.parse(localStorage.getItem('tq_new_notice'))
      if (newids && newids.indexOf(id) > -1) {
        newids.splice(newids.indexOf(id), 1)
      }
      localStorage.setItem('tq_new_notice', JSON.stringify(newids))

      window.sessionStorage.setItem('selectnPage', this.selectPage)
      this.$router.push({
        name: 'noticedetail',
        params: {
          articleId: id
        }
      })
    },
    DateFormate: function(timer) {
      //   var timezone = 8; //目标时区时间，东八区
      // var offset_GMT = new Date().getTimezoneOffset();
      // var offset_GMT_Time = -offset_GMT/60;
      // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
      const date = new Date(timer)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var min = date.getMinutes()
      var sec = date.getSeconds()
      ;[year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
      ].map((item) => (item < 10 ? '0' + item : item))
      return `${year}-${month}-${day} ${hour}:${min}:${sec}`
    },
    getArticle() {
      this.list = []
      const that = this
      // const localeLanguage =
      //   localStorage.lang || navigator.language.slice(-2).toLowerCase()
      // protocol.param_getArticle.param.articleId = ''
      // protocol.param_getArticle.param.articleTitle = this.inputSearch
      protocol.param_noticeList.param.page = this.pageData.currentPage - 1
      protocol.param_noticeList.param.size = this.pageData.pageSize
      http.getRes(protocol.param_noticeList).then((response) => {
        const { content, totalElements } = response.data.value
        that.pageData.total = Number(totalElements)
        if (content) {
          const newids = JSON.parse(localStorage.getItem('tq_new_notice'))

          for (const value of content) {
            const obj = value
            // if (localeLanguage == 'en') {
            //   obj.title = value.articleTitle
            // } else {
            //   obj.title = value.articleTitle
            // }
            obj.time = this.$options.methods.DateFormate(
              Number(value.createTime)
            )
            obj.newnotice = false
            for (const i in newids) {
              // eslint-disable-next-line no-prototype-builtins
              if (newids.hasOwnProperty(i)) {
                const element = newids[i]
                if (element == obj.id) {
                  obj.newnotice = true
                }
              }
            }
            // obj.content = value.articleContent
            this.list.push(obj)
          }
        }
      })
    },
    getArticleProject() {
      this.list = []
      const that = this
      const localeLanguage =
        localStorage.lang || navigator.language.slice(-2).toLowerCase()
      protocol.param_getArticle.param.classifyId = 4 // 项目公告
      protocol.param_getArticle.param.articleId = ''
      protocol.param_getArticle.param.articleTitle = this.inputSearch
      protocol.param_getArticle.param.page = this.pageData1.currentPage
      protocol.param_getArticle.param.limit = this.pageData1.pageSize
      http.postFront(protocol.param_getArticle).then((response) => {
        const { code, total, item } = response.data.value
        that.pageData1.total = Number(total)
        if (code == '0') {
          for (const value of item) {
            const obj = {}
            obj.id = value.articleId
            obj.sign = value.top == '1'
            if (localeLanguage == 'en') {
              obj.title = value.articleTitle
            } else {
              obj.title = value.articleTitle
            }
            obj.time = this.$options.methods.DateFormate(
              Number(value.publishTime)
            )
            obj.content = value.articleContent
            this.list.push(obj)
          }
        }
      })
    },
    searchNotice() {
      if (this.selectPage == 1) {
        this.pageData.currentPage = 1
        this.getArticle()
      } else {
        this.pageData1.currentPage = 1
        this.getArticleProject()
      }
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getArticle()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.getArticle()
    },
    handleSizeChange1(val) {
      this.pageData1.pageSize = val
      this.getArticleProject()
    },
    handleCurrentChange1(val) {
      this.pageData1.currentPage = val
      this.getArticleProject()
    }
    // choicePage(index) {
    //   if (this.selectPage == index) {
    //     return
    //   } else {
    //     this.inputSearch = ''
    //     this.selectPage = index
    //     switch (index) {
    //       case 1: // 公告中心

    //         protocol.param_getArticle.param.classifyId = 2
    //         this.getArticle()

    //         break
    //       case 2: // 项目公告

    //         protocol.param_getArticle.param.classifyId = 4
    //         this.getArticleProject()

    //         break
    //       default:
    //         break
    //     }
    //   }
    // }
  }
}
</script>
<style scoped lang="scss">
/deep/ .assets-comment-all {
  width: 100% !important;
}
.noticeTlt {
  margin-top: 30px;
  margin-bottom: 20px;
  height: 65px;
  background-color: transparent;
  line-height: 65px;
  font-family: 'MicrosoftYaHei', '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #ffffff;
}
.noticeTlt /deep/ .el-input__inner {
  background-color: transparent;
  border-radius: 19px;
  overflow: hidden;
  border: 1px solid rgba(64, 144, 253, 1);
  color: #b0b8db;
}
.noticeTlt /deep/ .el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b0b8db;
}

.noticeTlt /deep/ .el-input__inner::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #b0b8db;
}

.noticeTlt /deep/ .el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #b0b8db;
}
.el-row {
  height: 68px;
  line-height: 68px;
}
.cardContent {
  min-height: 300px;
}
#NoticeList /deep/ .el-card{
  margin-top: 30px;
}
.el-col-1{
  width: 20px;
}
.box-card /deep/ .el-card__body {
  padding: 30px 60px;
}
.cardContent .el-row {
  cursor: pointer;
  border-bottom: 1px solid rgba(240, 244, 250, 0.2);
}
.alignRight{
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}
.notice_content {
  height: 68px;
  line-height: 68px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  .newnotice{
    background: red;
    color: white;
    padding: 0 5px;
    border-radius: 7px;
    font-size: 12px;
    line-height: 14px;
    margin-right: 20px;
  }
}
.subTitle {
  width: 200px;
  cursor: pointer;
  text-align: center;
  height: 50px;
  line-height: 50px;
  margin: 0 auto;
  border-radius: 25px;
  overflow: hidden;
  border: 1px solid #2483ff;
}
.isSelected {
  color: #2483ff;
}
#NoticeList /deep/ .box-card {
  background-color: #263562;
  margin-bottom: 50px;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
.box-card /deep/ .el-card__header {
  background-color: transparent;
}
#NoticeList /deep/ .el-pagination .el-select .el-input .el-input__inner {
  background-color: transparent;
  border-color: transparent;
}
#NoticeList /deep/ .el-pagination button:disabled,
#NoticeList /deep/ .el-pagination .btn-prev,
#NoticeList /deep/ .el-pagination .btn-next,
#NoticeList /deep/ .el-pager li,
#NoticeList /deep/ .el-pagination__editor.el-input .el-input__inner {
  background-color: transparent;
}
#NoticeList /deep/ .el-pagination__total {
  color: #b0b8db;
}
#NoticeList /deep/ .el-pagination .el-select .el-input .el-input__inner {
  color: #b0b8db;
  border-color: #b0b8db;
}
#NoticeList /deep/ .el-pagination__jump {
  color: #b0b8db;
}
#NoticeList /deep/ .el-pagination__editor.el-input .el-input__inner {
  color: #b0b8db;
  border-color: #b0b8db;
}
.el-pagination{
  text-align: center;
  padding-top: 40px;
}
</style>
